module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('label', [_vm._v("输入课程名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lessionName),
      expression: "lessionName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入课程名"
    },
    domProps: {
      "value": (_vm.lessionName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lessionName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('mavon-editor', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "value": _vm.initEditorValue
    },
    on: {
      "htmlcode": true,
      "save": _vm.saveEditor
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3ae4f52","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/editor/editor.vue
// module id = 526
// module chunks = 1